import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_BENUTZER_DETAIL_ADMIN = '[BenutzerverwaltungModul] GetBenutzerDetailAdmin laden';
export const GET_BENUTZER_DETAIL_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerDetailAdmin ausführen';
export const GET_BENUTZER_DETAIL_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerDetailAdmin laden erfolgreich';
export const GET_BENUTZER_DETAIL_ADMIN_FEHLER = '[BenutzerverwaltungModul] GetBenutzerDetailAdmin Ladefehler';
export const GET_BENUTZER_DETAIL_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerDetailAdmin nicht ausgeführt (evtl. Offline)';


export class GetBenutzerDetailAdminAction implements Action {
    readonly type = GET_BENUTZER_DETAIL_ADMIN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerDetailAdminAusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_DETAIL_ADMIN_AUSFUEHREN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerDetailAdminErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_DETAIL_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerDetailForAdmin,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerDetailAdminFehlerAction implements Action {
    readonly type = GET_BENUTZER_DETAIL_ADMIN_FEHLER;
        constructor(public payload: any,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerDetailAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_DETAIL_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerDetailAdminActions =
    GetBenutzerDetailAdminAction
    | GetBenutzerDetailAdminAusfuehrenAction
    | GetBenutzerDetailAdminErfolgreichAction
    | GetBenutzerDetailAdminFehlerAction
    | GetBenutzerDetailAdminNichtAusgefuehrtAction
    ;
